import React, {useEffect, useState} from "react";
import {getCategories} from "../../service/myProductService";

import './menu.css';
import HtmlParser from "react-html-parser";
const MenuNav =()=>{
    const over=(e)=> {
        e.target.style.background = 'red';
        const childElement = document.getElementById("item");  
        const parentElement = childElement.parentNode;  
        console.log(parentElement);
    }
    const out=(e)=> {
        console.log('out');
    }
    const [cusMenu, setCusMenu] = useState('');
    var _string = '';
      const getDataCategories= async()=>{
        await getCategories().then((response)=>{
            if(+response.status === 200){
                window.localStorage.setItem('itemCate', JSON.stringify(response.message));
                window.localStorage.setItem('cateNode', true);
                if(response.message.length>0){
                    _string +='<div class="menu-wrapper w-100 mt-1" role="navigation"><ul class="menu mx-auto text-center position-relative" role="menubar">';
                    response.message.forEach(element => {
                        _string = _string + '<li role="menuitem"><a href="/'+element.url_key+'.html">'+element.name+'</a>';
                            if(element.child?.length > 0){
                                _string = _string +  '<div class="mega-menu bg-danger bg-white position-absolute top-100 z-3 pb-1 mb-3" aria-hidden="true" role="menu">';
                                        var _fg= false;
                                        var _count = 0;
                                          element.child?.forEach((element1,i) => {
                                            
                                            if(i > 1 && _fg === true && (element1.child?.length+_count>5)){
                                                _string = _string +  '</div>';
                                                _fg= false;
                                                _count=0;
                                            }

                                            _count = _count + element1.child?.length;
                                            if(_fg === false){
                                                _string = _string +  ' <div class="nav-column">';
                                            }    
                                            _fg = true;
                                            _string = _string +  '<span class="box-class-menu"><a href="/'+element1.url_key+'.html" class="position-relative z-1 title_menu-child"><span class="text-start">'+element1.name+'</span></a><ul>';
                                            element1.child?.splice(0,4).forEach(element2 => {
                                                _string = _string +  '<li role="menuitem item"><a href="/'+element2.url_key+'.html">'+element2.name+'</a></li>';
                                            });
                                            if(element1.child?.length>0){
                                                _string = _string +  '<li role="menuitem"><a href="/'+element1.url_key+'.html" class="view--all">Xem tất cả <i class="fa-solid fa-chevron-right ps-1"></i></a></li>';
                                            }
                                            _string = _string +  '</ul></span>';
                                            _count = _count +1;
                                            if(_count>4){
                                                _fg= false;
                                                _count=0;
                                            }
                                            if(_fg === false){
                                                _string = _string +  '</div>';
                                            } 
                                        });

                                _string = _string +  '</div>';
                            }

                        _string = _string +  '</li>';
                    });
                    _string = _string + '</ul></div>';
                }
                setCusMenu(_string);
            }
        });
      }
      useEffect(()=>{
        getDataCategories("","","");
      },[]);
    return(
       HtmlParser(cusMenu) 
    )
}

export default MenuNav;